import React from 'react';
import BadgeCard from '../../badge/Badge';
import { AppLoader } from '../../appLoader/AppLoader';
import { Dismiss20Regular } from '@fluentui/react-icons'; // Regular style
import { cn } from '../../../helpers/shadcnUtils.helper';
import { ArrowLeft24Filled } from '@fluentui/react-icons';
import { useTranslation } from 'react-i18next';
interface RightPanelProps {
  element?: JSX.Element | null;
  placeHolder?: JSX.Element | null;
  closeAction?: () => void;
  isLoadingData?: boolean;
  badgeInfo?: {
    label?: string;
    upperLabel?: string;
    colorClass?: string;
  } | null;
  description?: string | JSX.Element | null;
  subDescription?: string | JSX.Element | null;
  infoStatus?: JSX.Element | null;
  iconBox?: JSX.Element | null;
  isShowingBackButton?: boolean;
  className?: string;
  complementaryInformation?: JSX.Element | null;
}

const RightPanel = ({
  element,
  placeHolder,
  closeAction,
  isLoadingData,
  badgeInfo,
  description,
  subDescription,
  infoStatus,
  isShowingBackButton,
  iconBox,
  className,
  complementaryInformation,
}: RightPanelProps) => {
  const { t } = useTranslation();
  return (
    <div
      className={cn(
        'hidden relative p-4 max-sm:pt-0  bg-white h-full overflow-x-hidden overflow-y-auto md:px-6 pb-14 md:mt-9  lg:block',
        closeAction && element && 'block',
        isLoadingData && 'block',
        isShowingBackButton
          ? 'md:max-h-auto'
          : 'md:max-h-[calc(100vh-112px)] md:h-[calc(100vh-112px)]   md:rounded-2xl',
        className,
      )}
    >
      {closeAction && element && (
        <div className="sticky top-0 z-10 py-4 pl-1 sm:hidden">
          <button
            onClick={closeAction}
            type="button"
            className="flex items-center p-0 text-base bg-transparent border-0 outline-none"
          >
            <ArrowLeft24Filled className="mr-2 text-blue-00" />
            <span className="font-medium text-blue-00">
              {t('buttons.back')}
            </span>
          </button>
        </div>
      )}
      <div
        className={`   flex -top-4   sticky bg-white z-20 items-center md:items-start   ${
          !description ? 'justify-end w-full  ' : 'pb-4  pt-3 justify-between '
        } `}
      >
        {description && (
          <div className="">
            <h5 className="text-lg font-bold">{description}</h5>
            {subDescription && (
              <p className="text-sm text-gray-500">{subDescription}</p>
            )}
            {badgeInfo && (
              <div className="mt-2">
                <BadgeCard {...badgeInfo} />
              </div>
            )}
            {complementaryInformation && (
              <div className="mt-2">{complementaryInformation}</div>
            )}
          </div>
        )}

        {closeAction && !!element && (
          <button
            onClick={closeAction}
            type="button"
            className="flex w-10 h-10 p-0 text-base text-center align-middle bg-transparent border-0 shadow-none outline-none max-sm:hidden"
          >
            <span className="flex items-center justify-center w-10 h-10 rounded-full text-blue-00 hover:bg-blue-95">
              <Dismiss20Regular />
            </span>
          </button>
        )}
      </div>

      {iconBox && <div className="mb-4">{iconBox}</div>}

      {element || placeHolder}

      {isLoadingData && (
        <div className="absolute inset-0 flex items-center justify-center">
          <AppLoader />
        </div>
      )}
    </div>
  );
};

export default React.memo(RightPanel);
